<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card flat class="box">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>
                        Fee Receipt Certificate
                    </strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-btn class="ma-2 no-display" id="wv_btn" tile outlined color="warning" @click="print()"> <v-icon
                    left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
            <v-row justify="center" align="center" class="no-display">
                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete rounded dense required v-model="ay" :items="ay_list" item-text="name"
                        item-value="id" label="Academic Year" outlined hide-details></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="userType == 'Employee'">
                    <v-autocomplete rounded dense required v-model="status" :items="status_list" item-text="name"
                        item-value="id" hide-details label="Learner Status" outlined></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="userType == 'Employee'">
                    <v-autocomplete rounded dense required v-model="learner" :items="learner_list" item-text="name"
                        item-value="lid" :loading="loader" hide-details label="Learners" outlined></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" v-else>
                    <v-autocomplete rounded dense required v-model="child" :items="children" item-text="name"
                        item-value="id" hide-details label="Children" outlined></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="userType == 'Employee'">
                    <v-autocomplete rounded dense required v-model="principal" :items="principal_list" item-text="name"
                        item-value="name" hide-details label="Principal" outlined></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" align="center">
                    <v-btn class="button" @click="getData()" :loading="fetch_loader">Generate / Fetch</v-btn>
                </v-col>
            </v-row>
            <div v-if="certificate_data" id="fee-certificate" class="certificate-container">
                <div class="certificate-header">

                    <div class="school-logo-section">
                        <img v-if="org_basic_data_by_medium.school_logo" :src="org_basic_data_by_medium.school_logo"
                            class="school-logo" />
                    </div>

                    <div class="school-details">

                        <div class="trust-name">
                            {{ org_basic_data_by_medium.trust_name }}
                        </div>

                        <div class="school-name">
                            {{ org_basic_data_by_medium.school_name }}
                        </div>
                        <!-- <h3 style="font-weight: normal;">(Permanently Non-aided English Medium School)</h3> -->
                        <div class="school-address">
                            {{ org_basic_data_by_medium.address }}
                        </div>

                    </div>

                    <div class="other-info">
                        Reg. No. {{ org_basic_data_by_medium.school_no }} <br>
                        Phone : {{ org_basic_data_by_medium.phone }} <br>
                        UDISE NO. {{ basic_student_data.udise_no }}<br>
                        Office mail ID - {{ org_basic_data_by_medium.email }}
                    </div>
                </div>

                <hr class="header-line">
                <div class="certificate-date">
                    Date :
                </div>

                <div class="ref-no">
                    Ref. No.
                </div>

                <div class="certificate-title">
                    FEE CERTIFICATE
                </div>

                <div class="certificate-description">

                    This is to certify that

                    <b>
                        {{ basic_student_data.student_name }}
                    </b>

                    is studying in

                    <b>
                        Standard {{ basic_student_data.standard }}
                    </b>.

                    His / Her parents

                    <b>
                        {{ basic_student_data.father_first_name }} / {{ basic_student_data.mother_first_name }}
                    </b>

                    has paid the following fees in the year

                    <b>
                        {{ academic_year_name }}
                    </b>.

                </div>

                <!-- FEE TABLE -->
                <table class="fee-table">

                    <thead>
                        <tr>
                            <th>Sr. No</th>
                            <th>Particulars</th>
                            <th>Amount in Rs.</th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr v-for="(fee, index) in certificate_fees" :key="index">

                            <td>
                                {{ index + 1 }}
                            </td>

                            <td class="particular">
                                {{ fee.component_name }}
                            </td>

                            <td>
                                {{ formatAmount(fee.amount) }}/-
                            </td>

                        </tr>

                        <tr>

                            <td>
                                {{ certificate_fees.length + 1 }}
                            </td>

                            <td class="total-text">
                                <b>Total</b>
                            </td>

                            <td>
                                <b>
                                    {{ formatAmount(total_amount) }}/-
                                </b>
                            </td>

                        </tr>

                    </tbody>

                </table>

                <!-- SIGNATURE -->
                <div class="signature-section">

                    <div>
                        Head-Master,
                        <br>
                        ({{ signing_authority_name }})
                        <br>
                        {{ org_basic_data_by_medium.school_name }}
                    </div>

                </div>

            </div>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            overlay: false,
            radios: null,
            ay: null,

            org_basic_data_by_medium: {},
            basic_student_data: {},
            student_fees_structure: [],

            certificate_data: false,
            certificate_fees: [],
            total_amount: 0,
            current_date: "",
            parent_name: "__________",
            academic_year_name: "",

            status_list: [
                { name: "Active", id: "0" },
                { name: "Temporary Inactive", id: "1" },
                { name: "Permanent Inactive", id: "2" },
            ],

            ay_list: [],
            status: "0",
            learner_list: [],
            learner: null,

            loader: false,
            fetch_loader: false,
            snackbar: false,
            snackbar_msg: "",
            color: "",
            userType: null,
            child: null,
            children: [],
            principal_list: [],
            principal: null,
            signing_authority_name: ""
        };
    },
    watch: {
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
        status() {
            if (this.ay) {
                this.getLearners();
            }
        }
    },
    mounted() {
        this.onLoad();
        this.getPricipalList();
        this.userType = localStorage.getItem("EPS-ut");
        if (this.userType == 'Parent') {
            this.getChildList();
        }
    },
    methods: {
        getPricipalList() {
            axios
                .post("Certificate/getPrincipalList")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.principal_list = res.data.principal_list;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },
        getData() {

            const learnerId =
                this.userType == "Employee"
                    ? this.learner
                    : this.child;

            if (!learnerId || !this.ay) {
                this.showSnackbar(
                    "#b71c1c",
                    `Please select Academic Year and ${this.userType == "Employee" ? "Learner" : "Child"
                    }`
                );
                return;
            }

            this.fetch_loader = true;
            this.overlay = true;

            const formData = {
                learner_id: learnerId,
                ay_id: this.ay,
                principal: this.principal,
                user_type: this.userType
            };

            axios
                .post("/Certificate/getFeeCertificate", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.org_basic_data_by_medium = res.data.org_basic_data_by_medium;
                        this.basic_student_data = res.data.basic_student_data;
                        this.student_fees_structure = res.data.student_fees_structure;
                        this.signing_authority_name = res.data.signing_authority_name;

                        this.prepareCertificateFees();

                        let selectedAY = this.ay_list.find(
                            ay => ay.id == this.ay
                        );
                        if (selectedAY) {
                            this.academic_year_name = selectedAY.name;
                        }
                        this.current_date = new Date().toLocaleDateString("en-GB");
                        this.certificate_data = true;

                    } else {
                        this.certificate_data = false;
                        this.showSnackbar( "#b71c1c", res.data.snackbar );
                    }

                })
                .catch((error) => {

                    console.log(error);

                    this.showSnackbar(
                        "#b71c1c",
                        "Something went wrong!!!"
                    );

                })
                .finally(() => {

                    this.fetch_loader = false;
                    this.overlay = false;

                });
        },
        prepareCertificateFees() {

            this.certificate_fees =
                this.student_fees_structure.map(fee => {

                    return {
                        component_name: fee.component_name,
                        amount: parseFloat(fee.paid_till_now || 0)
                    };

                });

            this.total_amount =
                this.certificate_fees.reduce(
                    (total, fee) => total + fee.amount,
                    0
                );

        },
        getLearners() {
            this.overlay = true;
            this.loader = true;

            const formData = {
                status: this.status
            };

            axios.post("/AccountingAndFees/getStudentsByAcademicYear", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.learner_list = res.data.stud_list;
                        this.loader = false;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                    this.loader = false;
                });
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        formatAmount(amount) {
            return Number(amount || 0).toLocaleString("en-IN");
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/AccountingAndFees/getAYListForProfile")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.ay_list = res.data.academic_year_list;
                        this.ay = res.data.current_ay;
                        this.getLearners();
                        this.overlay = false;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        this.overlay = false;
                        return;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                    this.overlay = false;
                })
                .finally(() => {
                    //close loader
                    this.overlay = false;
                });
        },
        getChildList() {
            axios
                .post("/AccountingAndFees/getChildList")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.children = res.data.learners;
                        this.academic_year_list = res.data.academicyearlist
                        this.selected_ay = res.data.current_ay;
                        this.selected_children = this.children[0];
                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        return;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },

};
</script>
<style scoped>
.certificate-container {
    width: 100%;
    max-width: 1100px;
    margin: 20px auto;
    padding: 30px 40px;
    background: white;
    color: black;
    font-family: "Times New Roman", serif;
}

.certificate-header {
    display: flex;
    align-items: center;
    min-height: 180px;
}

.school-logo-section {
    width: 18%;
    text-align: center;
}

.school-logo {
    width: 130px;
    max-height: 130px;
    object-fit: contain;
}

.school-details {
    width: 60%;
    text-align: center;
}

.trust-name {
    font-family: Arial, sans-serif;
    color: #087ac1;
    font-size: 22px;
    margin-bottom: 20px;
}

.school-name {
    font-family: Arial, sans-serif;
    font-size: 25px;
    font-weight: bold;
}

.school-address {
    font-size: 20px;
    font-weight: bold;
    margin-top: 10px;
}

.school-contact {
    font-size: 17px;
    margin-top: 8px;
}

.email {
    color: #087ac1;
    text-decoration: underline;
}

.header-line {
    border: none;
    border-top: 1px solid #168ed1;
    margin: 10px 0;
}

.certificate-date {
    text-align: right;
    font-size: 18px;
    margin-top: 10px;
    text-decoration: underline;
    margin-right: 260px;
}

.ref-no {
    font-size: 18px;
    margin-top: 20px;
}

.certificate-title {
    text-align: center;
    font-size: 26px;
    font-weight: bold;
    margin: 10px 0 25px 0;
}

.certificate-description {
    width: 80%;
    margin: auto;
    font-size: 22px;
    line-height: 1.5;
    text-align: left;
}

.fee-table {
    width: 75%;
    margin: 25px auto 0 auto;
    border-collapse: collapse;
    font-size: 17px;
}

.fee-table th,
.fee-table td {
    border: 1px solid black;
    padding: 12px;
    text-align: center;
}

.fee-table th:nth-child(1),
.fee-table td:nth-child(1) {
    width: 15%;
}

.fee-table th:nth-child(2),
.fee-table td:nth-child(2) {
    width: 60%;
}

.fee-table th:nth-child(3),
.fee-table td:nth-child(3) {
    width: 25%;
}

.fee-table .particular {
    text-align: left;
}

.total-text {
    text-align: left !important;
}

.signature-section {
    width: 75%;
    margin: 55px auto 0 auto;
    font-size: 21px;
    line-height: 1.5;
}

@media print {

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    @page {
        size: A4 portrait;
        margin: 0mm;
        margin-top: -70px !important;
    }

    body {
        margin: 0 !important;
        padding: 0 !important;
    }

    .v-card {
        border: none !important;
        background: none !important;
    }

    .certificate-container {
        width: 100%;
        max-width: none;
        margin: 0;
        padding: 10px;
    }

    .certificate-header {
        min-height: 150px;
    }

    .trust-name {
        font-size: 18px;
    }

    .school-name {
        font-size: 21px;
    }

    .school-address {
        font-size: 17px;
    }

    .school-contact {
        font-size: 15px;
    }

    .certificate-title {
        font-size: 22px;
    }

    .other-info {
        font-size: 13px !important;
    }

    .certificate-description {
        font-size: 18px;
        width: 80%;
    }

    .fee-table {
        width: 75%;
        font-size: 17px;
    }

    .fee-table th,
    .fee-table td {
        padding: 8px;
    }

    .signature-section {
        width: 75%;
        font-size: 18px;
        margin-top: 45px;
    }

    .school-logo {
        width: 100px;
        max-height: 100px;
        object-fit: contain;
    }
}
</style>
